const ActionVoucherProductType = {
  UPDATE_PRODUCT_INFO: 1,
  PUBLIC_ON_PORTAL: 2,
  TAKE_DOWN_FROM_PORTAL: 3
}
export default ActionVoucherProductType
